import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../services/context/AuthContext';

const Logout = ({ onLogout }) => {
  
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const { logout: logoutAuth } = useAuth();

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth' // Smooth scroll behavior
    });
  };

  const handleLogout = async (e) => {
    e.preventDefault();
    try {
      logoutAuth(navigate);
      scrollToTop();
      setError(null);
    } catch (error) {
      setError(error.message);
    }
  };

  return (
    <div>
      <form onSubmit={handleLogout}>
        <button className='main-btn' type='submit'>Sair</button>
        {error}
      </form>
    </div>
  );
};

export default Logout;

